import { useState } from 'react';

import { type NotificationTypeDto } from '@/api/generated/models/notification-type-dto';
import { type NotificationsListDto } from '@/api/generated/models/notifications-list-dto';
import { useApiClient } from '@/api/util/useApiClient.util';

interface Return {
  getNotifications: (
    notificationType?: Array<NotificationTypeDto>,
  ) => Promise<NotificationsListDto>;
  isFetchingGetNotifications: boolean;
}

export const useGetNotifications = (): Return => {
  const { notificationApi } = useApiClient();
  const [isLoading, setIsLoading] = useState(false);
  return {
    getNotifications: async request => {
      setIsLoading(true);
      const notifications: NotificationsListDto = { notifications: [] };
      try {
        const response = await notificationApi.getNotifications(request);
        if (response?.data) {
          notifications['notifications'] = response.data.notifications;
        }
      } finally {
        setIsLoading(false);
      }

      return notifications;
    },
    isFetchingGetNotifications: isLoading,
  };
};
